"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelButtonContainer = exports.CustomPaper = exports.FilterButtonContainer = exports.DayTimeFiltersWrapper = exports.DatePicker = exports.FilterByMessage = exports.FilterContainer = exports.FilterOptionsWrapper = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const paper_1 = __importDefault(require("@kyruus/paper"));
exports.FilterOptionsWrapper = (0, styled_1.default)('div') `
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: 4px;

  display: flex;

  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  row-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  padding: 12px ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  position: sticky;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }
`;
exports.FilterContainer = (0, styled_1.default)('div') `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  position: sticky;
  top: 3rem;
  padding-top: 2rem;
  z-index: 11;
`;
exports.FilterByMessage = (0, styled_1.default)('span') `
  width: 100%;
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
    width: auto;
  }
`;
exports.DatePicker = (0, styled_1.default)('div') `
  flex: 0 0 auto;

  .SingleDatePickerInput,
  .SingleDatePickerInput__withBorder,
  .DateInput,
  .DateInput_input {
    background: none;
  }

  .SingleDatePickerInput {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};

    &:focus,
    &:focus-visible,
    &:focus-within,
    &:hover {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')};
    }

    input.DateInput_input {
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      &::placeholder {
        opacity: 1;
        color: ${(0, ui_theme_1.fromTheme)('color_text')};
      }
    }

    .SingleDatePickerInput_calendarIcon {
      > svg {
        fill: ${(0, ui_theme_1.fromTheme)('color_text')};
      }
    }
  }

  &.active {
    .SingleDatePickerInput {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button')};
      border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
        ${(0, ui_theme_1.fromTheme)('color_button')};
      &:focus,
      &:focus-visible,
      &:focus-within,
      &:hover {
        background-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
        border-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
      }
    }

    input.DateInput_input {
      color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};

      &::placeholder {
        opacity: 1;
        color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
      }
    }

    .SingleDatePickerInput_calendarIcon {
      > svg {
        fill: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
      }
    }
  }

  > div {
    text-align: center;

    @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
      text-align: left;
    }

    &:first-of-type {
      .SingleDatePickerInput,
      .SingleDatePickerInput__withBorder {
        border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
      }

      .SingleDatePicker_picker {
        z-index: 1000;
      }

      .SingleDatePickerInput__showClearDate {
        padding: 0;
      }

      .SingleDatePickerInput_clearDate {
        padding: 0;
        margin: 0;
        background: none;
      }

      .SingleDatePickerInput_calendarIcon {
        margin: 0;
        padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')}
          ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
        vertical-align: baseline;

        &:focus,
        &:hover {
          outline: none;
        }
      }

      .SingleDatePickerInput .DateInput {
        background: none;
        width: 123px;

        .DateInput_input {
          border: none;
          cursor: pointer;
          text-align: left;
          width: 100%;
          font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
          font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
          padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_small')}
            ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
        }
      }

      .DayPicker__withBorder {
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
          0px 4px 5px 0px rgba(0, 0, 0, 0.14),
          0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      }
      .DateInput_fang {
        z-index: 1001;
      }
      .DateInput_fangStroke {
        stroke: ${(0, ui_theme_1.fromTheme)('color_background')};
        fill: ${(0, ui_theme_1.fromTheme)('color_background')};
      }
    }
  }
`;
exports.DayTimeFiltersWrapper = (0, styled_1.default)('div') `
  display: flex;

  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: calc(${(0, ui_theme_1.fromTheme)('spacing_small')} / 2);
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  flex: 1 1 auto;

  text-align: center;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    row-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};

    text-align: right;
  }

  &::before {
    display: none;
    content: '';
    flex-grow: 1;

    @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
      display: initial;
    }
  }

  > span {
    flex-grow: 2;

    @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')}) {
      flex-basis: 100%;
    }
  }
`;
exports.FilterButtonContainer = (0, styled_1.default)('div') `
  position: relative;
  background: none;

  > button {
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 120px;
  }
`;
exports.CustomPaper = (0, styled_1.default)(paper_1.default) `
  position: absolute;
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-align: left;
  top: 50px;
  z-index: 1000;

  &::before {
    background: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-top: 2px solid ${(0, ui_theme_1.fromTheme)('color_background')};
    border-left: 2px solid ${(0, ui_theme_1.fromTheme)('color_background')};
    border-radius: 2px;
    content: '';
    display: block;
    height: 15px;
    position: absolute;
    top: -7px;
    transform: rotate(45deg);
    width: 15px;
  }

  &.left {
    left: 0;

    &::before {
      left: 20px;
    }
  }
  &.right {
    right: 0;

    &::before {
      right: 20px;
    }
  }
`;
exports.CancelButtonContainer = (0, styled_1.default)('div') `
  margin-top: 12px;
  button {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
//# sourceMappingURL=styles.js.map